import {
  injectRequiredWithSelf,
  checkValuesAlreadyProvided,
  CreateInjectionKeysRecord,
  type InjectionValuesRecord,
  type InjectionKeysRecord,
} from "@mcwd/util-vue";
import { exhaustiveGuard } from "@mcwd/typescript-type-guards";
import { useFormLogger } from "./use-form-logger.js";
import { provide } from "vue";

import { LocaleConvert, LocaleUrlPrefix, SiteCountryCode, isSiteCountryCode } from "../../types-and-definitions/locale-defs/Locales.js";

type UseSiteLanguageInjectionValues = InjectionValuesRecord<{
  siteCountryCode: SiteCountryCode;
  localeUrlPrefix: LocaleUrlPrefix;
}>;

type UseSiteLanguageInjectionKeys = InjectionKeysRecord<UseSiteLanguageInjectionValues>;

const UseSiteLanguageInjectionKeys = CreateInjectionKeysRecord<UseSiteLanguageInjectionKeys>({
  siteCountryCode: "siteCountryCode",
  localeUrlPrefix: "localeUrlPrefix"
});

export function initSiteLanguage(siteCountryCode: SiteCountryCode) {
  if (checkValuesAlreadyProvided(UseSiteLanguageInjectionKeys)) {
    return;
  }
  if (isSiteCountryCode(siteCountryCode)){
    provide(UseSiteLanguageInjectionKeys.siteCountryCode, siteCountryCode);
    provide(UseSiteLanguageInjectionKeys.localeUrlPrefix, LocaleConvert.FromSiteCountryCode.ToUrlPrefix(siteCountryCode, true));
  }
  else {
    exhaustiveGuard(siteCountryCode);
  }
}

export const useSiteLanguage = ({ callerLabel }: { callerLabel?: string | undefined } = {}) => {
  const { logger } = useFormLogger();
  try {
    const siteCountryCode = injectRequiredWithSelf(UseSiteLanguageInjectionKeys.siteCountryCode);
    const localeUrlPrefix = injectRequiredWithSelf(UseSiteLanguageInjectionKeys.localeUrlPrefix);
    return { siteCountryCode, localeUrlPrefix };
  } catch (err) {
    logger.error(`InjectionError from ${callerLabel ?? "unknown"}`);
    throw err;
  }
};
